import { render, staticRenderFns } from "./car-card.vue?vue&type=template&id=5e5cc06c&"
import script from "./car-card.vue?vue&type=script&lang=js&"
export * from "./car-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports